// GENERATED FILE -- DO NOT EDIT BY HAND.
// Regenerate:  python scripts/render-disclaimers.py   (from the repository root)
// Source of truth: config/disclaimers.json. Gate: scripts/verify-sample-data-disclaimer.py.
//
// Every illustrative interface (a marketing mock of a shipped screen, the interactive demo's exports,
// a dashboard panel showing demo data) says the same thing in the same words, from here.

export const SAMPLE_DATA_DISCLAIMER_TEMPLATE = "Illustrative interface with sample data, in the shipped {surface}'s structure. Not a customer environment and not a live feed.";
export const SAMPLE_DATA_NOTICE = "Sample data from the Agentomy interactive demo. Not a customer environment and not a live feed.";
export const SAMPLE_DATA_BADGE = "Sample data";

/** The one sentence, with the shipped surface it mirrors named (e.g. "Command Center", "dashboard"). */
export function sampleDataDisclaimer(surface: string): string {
  return SAMPLE_DATA_DISCLAIMER_TEMPLATE.replace("{surface}", surface);
}
